import React from 'react';
import { RadioSelect } from '../../RadioSelect';
import { getFilteredAccommodationTypes } from '../../../utils/park-static-data/defaultData';
export const AccommodationTypeSelector = ({ onSelect, accommodationType = '', validAccommodationTypes, handleGTMFilterChange, }) => {
    const innerOnClick = (value) => {
        onSelect(value);
        handleGTMFilterChange('types of accommodation', value || 'any');
    };
    const accommodationTypes = getFilteredAccommodationTypes(validAccommodationTypes);
    return (<RadioSelect onChange={innerOnClick} values={accommodationTypes} value={accommodationType}/>);
};
